import { axiosInstance } from "../../utils";

const actions = {
    FETCH_PAYMENTS_REQUESTED: 'FETCH_PAYMENTS_REQUESTED',
    FETCH_PAYMENTS_SUCCEEDED: 'FETCH_PAYMENTS_SUCCEEDED',
    FETCH_PAYMENTS_FAILED: 'FETCH_PAYMENTS_FAILED',

    FETCH_PAYMENT_REQUESTED: 'FETCH_PAYMENT_REQUESTED',
    FETCH_PAYMENT_SUCCEEDED: 'FETCH_PAYMENT_SUCCEEDED',
    FETCH_PAYMENT_FAILED: 'FETCH_PAYMENT_FAILED',

    fetchPayments: (params = undefined) => {
        return {
            type: actions.FETCH_PAYMENTS_REQUESTED,
            payload: params
        }
    },

    fetchPayment: (id = undefined) => {
        return {
            type: actions.FETCH_PAYMENT_REQUESTED,
            payload: id
        }
    },

    getPayments: async (params = undefined) => {
        const url = `payments`;

        try {
            const payments = await axiosInstance.get(url,{ params });
            return payments.data;
        } catch (error) {
            throw error;
        }
    },

    getPayment: async (paymentId = undefined) => {
        const url = `payments/`+paymentId;

        try {
            const payment = await axiosInstance.get(url);
            return payment.data;
        } catch (error) {
            throw error;
        }
    }
};
export default actions;
